import { getContext } from '@/context';

const isWindows = (): boolean => {
  try {
    return getContext().handlers.isWindows();
  } catch {
    return false;
  }
};

export default isWindows;
